import React, {useState} from 'react';
import isBoolean from 'lodash/isBoolean';

import AddIcon from '@mui/icons-material/Add';
import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import CaseForm from './CaseForm';

const EditCaseButton = props => {
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const {iconOnly, textOnly} = props;
  const childProps = {
    onClick: () => setDialogIsOpen(true),
    disabled: false,
    variant: iconOnly ? null : (props.variant || 'contained'),
    color: iconOnly ? 'primary' : undefined,
    startIcon: iconOnly || textOnly ? null : (props.editing ? <EditIcon/> : <AddIcon/>),
    fullWidth: props.fullWidth || null,
    size: props?.size,
  };
  const onClose = () => setDialogIsOpen(false);
  return (
    <>
      <Dialog
        open={dialogIsOpen}
        fullWidth={true}
        maxWidth='md'
        onClose={onClose}
      >
        <DialogContent>
          <CaseForm
            caseId={props.caseId}
            patientId={props?.patientId || props?.session?.patient?.id}
            editing={isBoolean(props.editing) ? props.editing : true}
            editableFields={props.editableFields}
            session={props?.session || null}
            requirePatientSex={true}
            afterSubmit={(e, params) => {
              onClose();
              if (props.afterSubmit) props.after(e, params);
            }}
          />
        </DialogContent>
      </Dialog>
      {
        iconOnly
        ? <Tooltip title={props?.buttonText || 'Edit Case'}>
          <IconButton {...childProps}>
            {props.editing ? <EditIcon/> : <AddIcon/>}
          </IconButton>
        </Tooltip>
        : <Button {...childProps}>
            {
              props?.buttonText ? props.buttonText : 'Edit'
            }
        </Button>
      }
    </>
  );
};

EditCaseButton.defaultProps = {
  editing: true,
  session: null,
};

export default EditCaseButton;